import { GenericListButtonLink } from "./GenericListButtonLink";
export default GenericListButtonLink;
